import { View } from 'react-native'
import { StyleSheet, useUnistyles } from 'react-native-unistyles'

import UniButton from '@/components/unistyles/UniButton'
import UniText from '@/components/unistyles/UniText'

interface TourTooltipProps {
  /** The current step's spotId — used as prefix for button testIDs */
  spotId: string
  text: string
  stepIndex: number
  totalSteps: number
  onNext: () => void
  onPrev: () => void
  onStop: () => void
}

const TourTooltip = ({
  spotId,
  text,
  stepIndex,
  totalSteps,
  onNext,
  onPrev,
  onStop,
}: TourTooltipProps) => {
  const { theme } = useUnistyles()
  const isFirst = stepIndex === 0
  const isLast = stepIndex === totalSteps - 1

  return (
    <View style={styles.container}>
      <UniText style={styles.text} variant="bodyLarge">
        {text}
      </UniText>
      <View style={styles.footer}>
        <UniText style={styles.stepCounter} variant="bodySmall">
          {`${stepIndex + 1} of ${totalSteps}`}
        </UniText>
        <View style={styles.buttons}>
          {!isLast && (
            <UniButton
              compact
              mode="text"
              onPress={onStop}
              testID={`${spotId}-skip-button`}
              theme={theme}
            >
              Skip
            </UniButton>
          )}
          {!isFirst && (
            <UniButton
              compact
              mode="text"
              onPress={onPrev}
              testID={`${spotId}-previous-button`}
              theme={theme}
            >
              Previous
            </UniButton>
          )}
          <UniButton
            compact
            mode="contained"
            onPress={isLast ? onStop : onNext}
            testID={`${spotId}-${isLast ? 'finish' : 'next'}-button`}
            theme={theme}
          >
            {isLast ? 'Finish' : 'Next'}
          </UniButton>
        </View>
      </View>
    </View>
  )
}

export default TourTooltip

const styles = StyleSheet.create((theme) => ({
  buttons: {
    flexDirection: 'row',
    gap: theme.tokens.spacing[2],
  },
  container: {
    backgroundColor: theme.colors.surface,
    borderColor: theme.colors.secondary,
    borderRadius: theme.tokens.containerBorderRadius,
    borderWidth: 3,
    padding: theme.tokens.spacing[4],
  },
  footer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  stepCounter: {
    color: theme.colors.subtitle,
  },
  text: {
    color: theme.colors.onSurface,
    marginBottom: theme.tokens.spacing[4],
  },
}))
